export default __webpack_public_path__ + "static/media/uploader-trivia-problem-2.cdc91992.png";